import React from 'react';
import { Popover, Tag } from 'antd';

/** Shape chung của `gift_summary` ở Đơn ECom (TCR-2626) và Đơn hàng (TCR-2625). */
export interface GiftSummaryLike {
  total_quantity: number;
  items: Array<{ product_id: string | null; name: string; sku: string | null; quantity: number }>;
}

/**
 * TCR-2626 / TCR-2625 — cột "Quà tặng" màn Đơn ECom và màn Đơn hàng. Đơn có SP thuộc danh mục Gift (kể cả trong combo) hiện
 * tag `🎁 n SP` với n = tổng số lượng quà; rê chuột hoặc click mở danh sách tên + SL. Không có quà
 * thì để trống.
 */
export function GiftSummaryCell({ summary }: { summary?: GiftSummaryLike | null }): React.ReactElement | null {
  if (!summary || summary.items.length === 0) return null;
  const content = (
    <div data-testid="gift-summary-popover" style={{ maxWidth: 320 }}>
      {summary.items.map((item, index) => (
        <div
          key={`${item.product_id ?? item.name}-${index}`}
          style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '2px 0' }}
        >
          <span>
            {item.name || item.sku || 'Sản phẩm quà tặng'}
            {item.sku && item.name ? <span style={{ color: '#8c8c8c' }}> · {item.sku}</span> : null}
          </span>
          <span style={{ whiteSpace: 'nowrap', fontWeight: 600 }}>x{item.quantity}</span>
        </div>
      ))}
    </div>
  );
  return (
    <Popover title="Sản phẩm quà tặng" content={content} trigger={['hover', 'click']}>
      <Tag
        color="magenta"
        style={{ cursor: 'pointer', marginInlineEnd: 0 }}
        onClick={(event) => event.stopPropagation()}
        aria-label={`Quà tặng ${summary.total_quantity} SP`}
      >
        🎁 {summary.total_quantity} SP
      </Tag>
    </Popover>
  );
}
